var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { useGlobalState } from '../../hooks';
import { Message } from './Message';
export function MessageManager() {
    var messages = useGlobalState().messages;
    return (_jsx(StyledMessageManager, { children: messages.map(function (m, i) { return (_jsx(Message, { message: m }, i)); }) }, void 0));
}
var StyledMessageManager = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  display: flex;\n\n  flex-direction: column;\n"], ["\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  display: flex;\n\n  flex-direction: column;\n"])));
var templateObject_1;
